import React from "react";
import { BsCheckLg } from "react-icons/bs";
import {
  CostumeID,
  CostumeCategory,
  CostumeSet,
  costumeRegistry,
  costumeCategoryRegistry,
} from "../../lib/costumes/Costume";
import "./CostumeUISelector.scoped.scss";

interface Props {
  category: CostumeCategory;
  costumes: CostumeSet;
  setCostumes: React.Dispatch<React.SetStateAction<CostumeSet>>;
}

export default function CostumeUISelector({
  category,
  costumes,
  setCostumes,
}: Props) {
  const categoryInfo = costumeCategoryRegistry[category];
  const categoryCostumes = Object.entries(costumeRegistry).filter(
    ([_, costume]) => costume.category === category
  );

  const updateCostume = (costume: CostumeID) => {
    const newCostumes = new Set(costumes);

    if (categoryInfo.multipleChoice) {
      if (newCostumes.has(costume)) {
        newCostumes.delete(costume);
      } else {
        newCostumes.add(costume);
      }
    } else {
      for (const costume of newCostumes) {
        if (costumeRegistry[costume].category === category) {
          newCostumes.delete(costume);
        }
      }
      newCostumes.add(costume);
    }

    setCostumes(newCostumes);
  };

  return (
    <div className="costume-ui-selector">
      {categoryCostumes.map(([costumeID, costume]) => {
        return (
          <div
            key={costumeID}
            className="rounded cursor-pointer costume-ui-option hover:bg-white hover:bg-opacity-50"
          >
            <label className="flex items-center justify-center cursor-pointer">
              <input
                type={categoryInfo.multipleChoice ? "checkbox" : "radio"}
                value={costumeID}
                checked={costumes.has(Number(costumeID) as CostumeID)}
                onChange={() => updateCostume(Number(costumeID) as CostumeID)}
              />
              <BsCheckLg
                className={
                  "text-green-400" +
                  (costumes.has(Number(costumeID) as CostumeID)
                    ? ""
                    : " opacity-10")
                }
              />
              <span className="w-full">{costume.name}</span>
            </label>
          </div>
        );
      })}
    </div>
  );
}
